import axios from "axios";

export default function deletePromoRule(code1, code2, jwt) {
  return new Promise((resolve, reject) => {
    const backend_url = process.env.REACT_APP_BACKEND_URL;
    let target = `${backend_url}/delete-promotion-rule`;
    console.log(code1 + " " + code2);

    axios({
      url: target,
      method: "POST",
      data: {code1: code1, code2: code2},
      headers: {
        Authorization: `Bearer ${jwt}`,
      },
    })
      .then((res) =>
        resolve({
          data: res.data,
          error: false,
          complete: true,
        })
      )
      .catch((e) => {
        reject({
          data: null,
          error: true,
          errorMessage: e.response.data,
          complete: true,
        });
      });
  });
}
